import STRINGS from '../../common/strings/strings';

export function ValidationUserDoc(data, fieldName, docId) {
    const { title, file } = data;
    let errors = {};
    let formValidCheck = true;

    // Title Validation
    if (title === '' && (fieldName === 'title' || fieldName === '')) {
        errors.title = STRINGS.titleReq;
        formValidCheck = false;
    }

    // File Validation
    if (!docId && !file && (fieldName === 'file' || fieldName === '')) {
        // If no docId exists and file is not provided, show the required error
        errors.file = STRINGS.fileReq;
        formValidCheck = false;
    } else if (file) {
        // If file is provided, validate type and filename
        const validTypes = [
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // DOCX
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'        // XLSX
        ];

        const isValidType = validTypes.includes(file.type);
        const hasMultipleSpaces = /\s{2,}/.test(file.name);

        if (!isValidType) {
            errors.file = STRINGS.InvalidFileType || "Invalid file type. Only PDF, DOCX, or XLSX are allowed.";
            formValidCheck = false;
        } else if (hasMultipleSpaces) {
            errors.file = "Filename cannot contain multiple consecutive spaces.";
            formValidCheck = false;
        } else {
            // ✅ File is valid – clear any previous file errors
            errors.file = '';
        }
    }

    return { formValidCheck, errors };
}
